window.addEventListener('load', () => {
  let imgs = document.querySelectorAll('img');
  imgs.forEach(img => {
    let src = img.src;
    let extension = src.split('.').pop();
    if (! extension.includes('gif')) return;

    img.addEventListener('mouseover', e => {
      let extension = src.substring(src.lastIndexOf('.'));
      let dashPos = src.lastIndexOf('-');
      if (! dashPos) return;

      img.src = src.substring(0, dashPos) + extension;
      img.setAttribute('srcset', '');
    }, { once: true });
  });

  // let animatedGIFs = document.querySelectorAll('.animated-gif');
  // animatedGIFs.forEach(img => {
  //   img.addEventListener('mouseover', e => {
  //     let src = img.src;
  //     let extension = src.substring(src.lastIndexOf('.'));
  //     let dashPos = src.lastIndexOf('-');
  //     if (!dashPos) return;
  //     img.src = src.substring(0, dashPos) + extension;
  //     img.setAttribute('srcset', '');
  //   }, { once: true });
  // });

  // // console.log('wpLightbox');
  // let anchors = document.querySelectorAll('.js-lightbox');
  // anchors.forEach(element => {
  //   element.setAttribute('data-fslightbox', '');
  // });
  // refreshFsLightbox();
});
